import React from "react";
import { TProductPricingEditing } from "types/api";

export const ProductPricingEditContext = React.createContext<{
    updateProductPricing: (productID: number, productPricings: TProductPricingEditing[]) => void;
  }>({} as any);